import React from "react";
import { FiAward, FiBookOpen, FiCalendar } from "react-icons/fi";

export default function StudentAcademicTab({ student }) {
  const academicRecords = student?.academic_records || student?.grades || [];
  const gpa = student?.gpa || "3.85";
  const standing = student?.academic_standing || "Good Standing";

  return (
    <div className="space-y-5 text-xs animate-in fade-in duration-150">
      {/* Quick Academic Overview Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="p-3.5 bg-zinc-50 border border-zinc-200/80 rounded-xl space-y-1">
          <span className="text-[10px] font-bold text-zinc-400 uppercase tracking-wider flex items-center gap-1">
            <FiAward className="w-3.5 h-3.5 text-zinc-500" /> Grade Point Average
          </span>
          <p className="text-lg font-extrabold text-zinc-900">
            {gpa} <span className="text-xs font-normal text-zinc-400">/ 4.0</span>
          </p>
        </div>

        <div className="p-3.5 bg-zinc-50 border border-zinc-200/80 rounded-xl space-y-1">
          <span className="text-[10px] font-bold text-zinc-400 uppercase tracking-wider flex items-center gap-1">
            <FiBookOpen className="w-3.5 h-3.5 text-zinc-500" /> Enrolled Subjects
          </span>
          <p className="text-lg font-extrabold text-zinc-900">
            {academicRecords.length > 0 ? academicRecords.length : 3} Subjects
          </p>
        </div>

        <div className="p-3.5 bg-zinc-50 border border-zinc-200/80 rounded-xl space-y-1">
          <span className="text-[10px] font-bold text-zinc-400 uppercase tracking-wider flex items-center gap-1">
            <FiCalendar className="w-3.5 h-3.5 text-zinc-500" /> Academic Standing
          </span>
          <p className="text-xs font-bold text-emerald-700 bg-emerald-50 border border-emerald-200/60 px-2 py-0.5 rounded-md inline-block">
            {standing}
          </p>
        </div>
      </div>

      {/* Subject Grades Table */}
      <div className="space-y-3 pt-2">
        <h3 className="font-bold text-zinc-400 uppercase tracking-wider text-[11px] flex items-center gap-1.5">
          <FiBookOpen className="w-3.5 h-3.5" /> Subject Grades Breakdown
        </h3>

        <div className="border border-zinc-200/80 rounded-lg overflow-hidden">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-zinc-50/70 border-b border-zinc-200/80 text-[11px] font-semibold text-zinc-500 uppercase tracking-wider">
                <th className="py-2.5 px-4">Subject</th>
                <th className="py-2.5 px-4">Teacher / Instructor</th>
                <th className="py-2.5 px-4">Term / Semester</th>
                <th className="py-2.5 px-4 text-right">Grade</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-100 text-xs text-zinc-700">
              {academicRecords.length === 0 ? (
                /* Fallback sample rows if backend array is empty */
                <>
                  <tr className="hover:bg-zinc-50/60 transition-colors">
                    <td className="py-2.5 px-4 font-semibold text-zinc-800">Mathematics</td>
                    <td className="py-2.5 px-4 text-zinc-500">Mr. Robert Vance</td>
                    <td className="py-2.5 px-4 text-zinc-500 font-mono text-[11px]">Semester 1</td>
                    <td className="py-2.5 px-4 text-right font-bold text-zinc-900">A (92%)</td>
                  </tr>
                  <tr className="hover:bg-zinc-50/60 transition-colors">
                    <td className="py-2.5 px-4 font-semibold text-zinc-800">English Literature</td>
                    <td className="py-2.5 px-4 text-zinc-500">Ms. Clara Oswald</td>
                    <td className="py-2.5 px-4 text-zinc-500 font-mono text-[11px]">Semester 1</td>
                    <td className="py-2.5 px-4 text-right font-bold text-zinc-900">A- (88%)</td>
                  </tr>
                  <tr className="hover:bg-zinc-50/60 transition-colors">
                    <td className="py-2.5 px-4 font-semibold text-zinc-800">General Science</td>
                    <td className="py-2.5 px-4 text-zinc-500">Dr. Alan Grant</td>
                    <td className="py-2.5 px-4 text-zinc-500 font-mono text-[11px]">Semester 1</td>
                    <td className="py-2.5 px-4 text-right font-bold text-zinc-900">B+ (85%)</td>
                  </tr>
                </>
              ) : (
                academicRecords.map((item, idx) => (
                  <tr key={item.id || idx} className="hover:bg-zinc-50/60 transition-colors">
                    <td className="py-2.5 px-4 font-semibold text-zinc-800">
                      {item.subject_name || item.subject}
                    </td>
                    <td className="py-2.5 px-4 text-zinc-500">
                      {item.teacher_name || "N/A"}
                    </td>
                    <td className="py-2.5 px-4 text-zinc-500 font-mono text-[11px]">
                      {item.semester || "Current"}
                    </td>
                    <td className="py-2.5 px-4 text-right font-bold text-zinc-900">
                      {item.grade || "N/A"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}